import { cn } from '@/lib/utils';

interface TestimonialHeroProps {
  quote: string;
  author: string;
  role?: string;
  backgroundImage?: string;
  className?: string;
}

export function TestimonialHero({
  quote,
  author,
  role,
  backgroundImage = 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80',
  className,
}: TestimonialHeroProps) {
  return (
    <section className={cn('relative min-h-[40vh] md:min-h-[50vh] flex items-center justify-center py-12 md:py-20', className)}>
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/70" />
      
      {/* Content */}
      <div className="container-custom relative z-10 text-center px-6 md:px-4">
        <div className="mx-auto max-w-3xl">
          <blockquote>
            <p className="font-display text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl leading-relaxed text-white">
              "{quote}"
            </p>
          </blockquote>
          <div className="mt-6 md:mt-8">
            <p className="text-base md:text-lg font-semibold text-primary">{author}</p>
            {role && <p className="mt-1 text-xs md:text-sm text-gray-400">{role}</p>}
          </div>
        </div>
      </div>
    </section>
  );
}
